import { uniqWith } from 'es-toolkit';
import React, { ReactNode } from 'react';
import { SxProps, Theme } from '@mui/material';

import { INDETERMINATE } from '@paragon/client-tools';
import { distanceEquals } from '@paragon/geometry-library';
import { DistanceField } from '@paragon/material';

export interface MultiValueDistanceInputProps {
  readonly sx?: SxProps<Theme>;
  readonly values: readonly number[];
  readonly submit: (newValue: number) => void;
  readonly label: ReactNode;
  readonly disabled?: boolean;
  readonly min?: number;
  readonly max?: number;
}

export function MultiValueDistanceInput(props: MultiValueDistanceInputProps) {
  const uniqueValues = uniqWith(props.values, distanceEquals);
  const value = uniqueValues.length === 1 ? uniqueValues[0] : INDETERMINATE;

  return (
    <DistanceField
      sx={props.sx}
      label={props.label}
      canBeIndeterminate
      value={value}
      min={props.min}
      max={props.max}
      onSubmit={props.submit}
      disabled={props.disabled}
      fullWidth={false}
    />
  );
}
